import { Component, Inject, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IonButton } from '@ionic/angular';
import Env from '@ridango/core/env';

@Component({
    selector: 'ridango-ui-tab-button',
    templateUrl: './tab-button.component.html',
    styleUrls: ['./tab-button.component.scss']
})
export class TabButtonComponent {
    @Input() isSelected: boolean;
    @Input() ariaLabel: number;
    @Input() tabsCount: number;
    @Input() tabIndex: number;

    constructor(
        @Inject('ENV') public env: Env,
        public translate: TranslateService
    ) {}

    getAriaLabel() {
        let label;

        if (this.isSelected) {
            label = this.translate.instant('SELECTED_TAB_AREA_LABEL');
        } else {
            label = this.translate.instant('TAB_AREA_LABEL');
        }

        if (!this.tabIndex || !this.tabsCount || !this.ariaLabel) {
            return `${label.split('{0}')[0]} ${this.ariaLabel || ''}`;
        }

        return label.replace('{0}', this.ariaLabel).replace('{1}', this.tabIndex).replace('{2}', this.tabsCount);
    }
}
